<template>
  <div>


      <h2 class="goth">Presens av haben</h2>

      <h4>haben = ha</h4>
          <p class="grammatikparagrafbredd leftorient">Som alla andra verb i tyskan får <i>haben</i> olika form i presens beroende på
              person, men formerna skiljer sig en aning från vanliga verb. I 2:a och 3:e person singular försvinner <i>b</i>:et från stammen.</p><br>


    <table class="">


        <tr class="leftorient">
            <td class="ljusgra">ich</td>
            <td class="ljusgra"><i><b>habe</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">du</td>
            <td class="rod ljusgra"><i><b>hast</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">er<br> es<br> sie</td>
            <td class="rod ljusgra"><i><b>hat</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra upperspace">wir</td>
            <td class="ljusgra"><i><b>haben</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ihr</td>
            <td class="ljusgra"><i><b>habt</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">sie<br> Sie</td>
            <td class="ljusgra"><i><b>haben</b></i></td>
        </tr>


    </table>

<br><br>
    <div class="ruta leftorient">
    <p><i><b>Ich habe</b> viel Spaß.<br>Jag har väldigt kul.</i></p>

    <p><i><b>Hast du</b> Zeit?<br>Har du tid?</i></p>

    <p><i><b>Sie hat</b> einen Bruder.<br>Hon har en bror.</i></p>

    <p><i><b>Wir haben</b> nichts gemacht.<br>Vi har inte gjort något.</i></p>

    <p><i><b>Ihr habt</b> vieles gelernt.<br>Ni har lär er mycket.</i></p>



    <p><i><b>Sie haben </b> ein großes Haus.<br>De har ett stort hus.</i></p>


    </div>







</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "presens haben"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
